import type { ReactNode, JSX} from "react";
import { cn } from "./cn";
import { Stack } from "./Stack";
import { Text } from "./Text";

export interface ProfileHeroProps {
  /** Avatar element */
  readonly avatar: ReactNode;
  /** Display name */
  readonly name: string;
  /** Subtitle (role, status, etc.) */
  readonly subtitle?: string;
  /** Extra className */
  readonly className?: string;
}

/**
 * A centered profile hero with avatar, name, and optional subtitle.
 * Used in contact detail views.
 */
export function ProfileHero({ avatar, name, subtitle, className }: ProfileHeroProps): JSX.Element {
  return (
    <Stack gap={2} align="center" className={cn("py-4", className)}>
      {avatar}
      <Text variant="heading" weight="semibold">{name}</Text>
      {subtitle ? <Text variant="body" color="tertiary">{subtitle}</Text> : null}
    </Stack>
  );
}
